import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal as BootstrapModal,
  Row,
  Col,
  Button,
  Image
} from 'react-bootstrap';
import classNames from 'classnames';
import closeRed from 'assets/img/close_red.svg';
import closeWhite from 'assets/img/close_white.svg';
import { useWindowSize } from 'hooks';
import { VARIANTS } from './config';
import styles from './styles.module.scss';

export default function ModalQR({
  onClose,
  onHide,
  show,
  className,
  title = '',
  titleHeader = '',
  titleHeaderClassName = '',
  titleClassName = '',
  subtitle = '',
  subtitleClassName = '',
  code = '',
  codeClassName = '',
  titleContainerClassName = '',
  close = true,
  closeLabel = 'Cancelar',
  submitLabel = 'Aceptar',
  actionLabel = 'Aceptar',
  withActionButtons = true,
  onSubmit,
  onAction,
  children,
  icon,
  altIcon = '',
  containerClassName = '',
  type = 'action',
  contentClassName = '',
  variant = VARIANTS.DEFAULT,
  variantOnlyInMobile = false,
  withHeader = false,
  dialogClassName = '',
  disabledSubmit = false,
  hide = false,
  ...props
}) {
  const [, { isMobile }] = useWindowSize();

  const getClassNameWithVariant = (style) => {
    const styleWithVariant = `${style}${variant}`;
    const classNameWithVariant =
      variant !== VARIANTS.DEFAULT
        ? variantOnlyInMobile
          ? classNames(isMobile ? styleWithVariant : style)
          : styleWithVariant
        : style;

    return styles[classNameWithVariant];
  };

  return (
    <BootstrapModal
      show={show}
      onHide={onHide || onClose}
      backdrop="static"
      keyboard={false}
      className={classNames(
        getClassNameWithVariant('Modal'),
        containerClassName,
        hide && 'd-none'
      )}
      contentClassName={getClassNameWithVariant('modalContent')}
      dialogClassName={`${getClassNameWithVariant(
        'dialog'
      )} ${dialogClassName}`}
      backdropClassName={classNames(hide && 'd-none')}
      {...props}
    >
      <BootstrapModal.Header className={ styles.headerRed }>
        {close && (
          <button id="close-modal" type="button" onClick={onHide || onClose}>
            <img src={closeWhite } alt="Cerrar ventana " />
          </button>
        )}
        { titleHeader.length ? 
          <div className={classNames(titleHeaderClassName)}>
            <h1><strong>{titleHeader}</strong></h1>
          </div>
        : null }
      </BootstrapModal.Header>

      <BootstrapModal.Body
        className={classNames(
          styles.body,
          contentClassName,
          variant === VARIANTS.COMPLETED &&
            'd-flex justify-content-between flex-column'
        )}
      >
        {icon && (
          <Row>
            <Col className="p-0 d-flex justify-content-center">
              <Image src={icon} alt={altIcon} />
            </Col>
          </Row>
        )}

        <div><br></br>
          {(title || subtitle) && (
            <div
              className={`${styles.titleContainer} ${titleContainerClassName}`}
            >
              {/*title && (
                <h3 className={`${styles.title} ${titleClassName}`}>{title}</h3>
              )*/}
              {subtitle && (
                <>
                  {typeof subtitle === 'string' ? (
                    <p className={`m-0 ${subtitleClassName}`}><center>{subtitle}</center></p>
                  ) : (
                    subtitle
                  )}
                </>
              )}
              {code && <p className={`m-0 ${codeClassName}`}>{code}</p>}
            </div>
          )}
          <div className={className}>{children}</div>
        </div>

        {withActionButtons && (
          <Row className="mt-4">
            {type === 'action' ? (
              <>
              {/*
                <Col xs={12} md={6} className="mb-3 mb-md-0">
                  <Button
                    block
                    onClick={onClose || onHide}
                    type="button"
                    variant="secondary"
                  >
                    {closeLabel}
                  </Button>
                </Col>
                */}
                <Col xs={12} md={12}>
                  <Button block type="submit" onClick={onSubmit || onAction} disabled={disabledSubmit}>
                    {submitLabel || actionLabel}
                  </Button>
                </Col>
              </>
            ) : (
              <>
                <Col />
                <Col xs={12} md={6}>
                  <Button block type="submit" onClick={onSubmit || onAction}>
                    {(!actionLabel || actionLabel === 'Aceptar') && submitLabel
                      ? submitLabel
                      : actionLabel}
                  </Button>
                </Col>
                <Col />
              </>
            )}
          </Row>
        )}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
}

ModalQR.propTypes = {
  onClose: PropTypes.func,
  onHide: PropTypes.func,
  show: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subtitleClassName: PropTypes.string,
  code: PropTypes.string,
  codeClassName: PropTypes.string,
  titleContainerClassName: PropTypes.string,
  close: PropTypes.bool,
  closeLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  actionLabel: PropTypes.string,
  withActionButtons: PropTypes.bool,
  onSubmit: PropTypes.func,
  onAction: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  icon: PropTypes.string,
  altIcon: PropTypes.string,
  containerClassName: PropTypes.string,
  type: PropTypes.string,
  contentClassName: PropTypes.string,
  variant: PropTypes.string,
  variantOnlyInMobile: PropTypes.bool,
  dialogClassName: PropTypes.string
};
